import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../shared/context/AuthContext";
import { consumePostLoginRedirect } from "../utils/postLoginRedirect";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { updateAuthToken } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("credential") || params.get("code");

    if (!token) {
      navigate("/login");
      return;
    }

    updateAuthToken(token);
    const redirected = consumePostLoginRedirect(navigate);
    if (!redirected) {
      navigate("/");
    }
  }, [navigate, updateAuthToken]);

  return <div>Signing you in…</div>;
};

export default AuthCallback;
